import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';

@Component({
	selector: 'app-waz-question',
	templateUrl: './waz-question.component.html',
	styleUrls: ['./waz-question.component.css']
})
export class WazQuestionComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any = 10;
	pageNo: any = 1;
	questionList:any =[];
	constructor(private router: Router, private pagerService: PagerService, 
		private authService: AuthService, private commonService:CommonService ) {
	}

	ngOnInit() {
		this.commonService.process();
		//this.commonService.setTitle();
		$(".navbar-brand").text("WAZ View Questions");
		this.getWorldViewQuestions(this.pageNo, this.limit);
	}

	// Get world view question's list.
	getWorldViewQuestions = function(pageNo, limit){
		this.commonService.process();
		this.authService.getWorldViewQuestionsList(pageNo, limit).subscribe(data=>{
			if(data.success){
				this.questionList = data.user;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.questionList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getWorldViewQuestions(page, this.limit);
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/waz-question/waz-question.component.ts